import React from 'react';
import PairPrintManager from '../printManager/PairPrintManager';

// The organization view uses the same authenticated pairing flow as Devices.
export default function AddDeviceModal({ onClose, onAdded }) {
  return <div className="modal"><PairPrintManager onClose={onClose} onConnected={onAdded} /></div>;
}
